module.exports = __webpack_public_path__ + "img/img_app_banner_back.69ccfb4.png";